// This is a partial file belonging to application views
window.sfDocumentReady(['route-application-edit'], async () => {
  toggleVisibility('product_status', getRadioValue('product_status'));
  $('[name="product_status"]').on('change', () =>
    toggleVisibility('product_status', getRadioValue('product_status'))
  );

  toggleVisibility('product_detail_fulfillment', getRadioValue('product_detail_fulfillment'));
  $('[name="product_detail_fulfillment"]').on('change', () => {
    toggleVisibility('product_detail_fulfillment', getRadioValue('product_detail_fulfillment'))
    handleProductDetailFulfillmentChange()
  });
  
  handleProductDetailFulfillmentChange()
  function handleProductDetailFulfillmentChange() {
    const value = getRadioValue('product_detail_fulfillment');
    $('.js-product-list').each(function () {
      if ($(this).data('visible') === `product_detail_fulfillment=${value}`) {
        $(this).removeClass('not_serialize')
      } else {
        $(this).addClass('not_serialize')
      }
    });
  }

  const reIndexProducts = container => {
    const templateName = $(container).data('template-container');

    $(container).find('.DocumentTable .js-product').each((productIndex, product) => {
      $(product).find('[data-template-attr]').each(function () {
        const attribute = $(this).data('template-attr');
        const attributeId = `${templateName}_${productIndex}_${attribute}`;

        $(this).attr('name', `${templateName}[${productIndex}][${attribute}]`)
          .attr('id', attributeId)
          // add class to error span
          .next('.error-span')
          .addClass(`${attributeId}-err`);
      });
    });
  }
  const getProductCount = container => $(container).find('.DocumentTable .js-product').length;
  const addProduct = container => {
    const templateName = $(container).data('template-container');
    const templateHtml = $(`.js-product-templates[data-template="${templateName}"]`).html()

    if (!templateHtml) {
      return;
    }

    const product = $(templateHtml.replace(/<\/?tbody>/g, ''));
    const isFirstRow = getProductCount(container) === 0;

    product.find('.js-positive-integers-only')
      .inputFilter(value => /^([1-9]\d*)?$/.test(value))
      .inputFilter(value => /^\d*$/.test(value));

    $(container).find('.DocumentTable').append(product);
    reIndexProducts(container);
    
    const productTypeSelect = product.find('.js-product-type-select');
    if (isFirstRow) {
      productTypeSelect.val('1').trigger('change');
    }
  };

  $('.js-product-list[data-template-container]').each(function () {
    $(this).find('.js-product-list-errors').hide();
    if (!getProductCount(this)) {
      addProduct(this);
    } else {
      reIndexProducts(this);
      $(this).find('.js-product-type-select').select2({ width: '100%' });
    }

    $(this).find('.js-add-product').on('click', e => {
      e.preventDefault();
      addProduct(this);
    });
  });

  $(document).on('click', '.js-delete-product', async function (e) {
    e.preventDefault();
    if (!confirm('Are you sure you want to delete this product?')) {
      return false;
    }

    const id = $(this).data('id');
    const productList = $(this).closest('.js-product-list')
    const productRow = $(this).parent()

    if (id) {
      try {
        await Api.delete(`api/v1/applications/delete-products/${id}`);
      } catch (err) {
        if (ajaxErrorHandler(err.response.status)) {
          return;
        }

        notifyBox('Error', 'Error occurred', 'error');
      }
    }

    productRow.remove();
    if (!getProductCount(productList)) {
      addProduct(productList);
    } else {
      reIndexProducts(productList);
    }
  });

  $('.js-product-type-select').each(function () {
    initProductAutocompletion(this);
  });
});

const getRadioValue = (name) => $(`[name="${name}"]:checked`).val();
